import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, switchMap, debounceTime, startWith } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import State from 'src/application/core/State';
import EstimationProductsReceived from '../events/EstimationProductsReceived';
import EstimationsGetRequested from '../../estimations/events/EstimationsRequested';
import EstimationProductsSearchRequested from '../../estimations/events/EstimationProductsSearchRequested';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import EstimationsFilterSelected from '../../order/events/EstimationsFilterSelected';
import EstimationsFilterRemoved from '../../order/events/EstimationsFilterRemoved';
import estimationQueryFactory from './productQueryFactory';
import EstimationProductsGetRequested from '../events/EstimationProductsGetRequested';
import EstimationProductsGetFailed from '../events/EstimationProductsGetFailed';
import RequestFailed from '../../core/events/RequestFailed';
import EstimationProductsNextRequested from '../events/EstimationProductsNextRequested';
import EstimationProductsPrevRequested from '../events/EstimationProductsPrevRequested';
import { getEstimationCurrentCursor } from '../selector';

const immediately = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(
            EstimationsGetRequested.type,
            EstimationsFilterSelected.type,
            EstimationsFilterRemoved.type,
            EstimationProductsNextRequested.type,
            EstimationProductsPrevRequested.type
        ),
        switchMap((event: Event) => getProducts(event, state$, backend))
    );

const withDelay = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationProductsSearchRequested.type),
        debounceTime(500),
        switchMap((event: Event) => getProducts(event, state$, backend))
    );

const getProducts = (event: Event, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    let url = `${api()}products${estimationQueryFactory(
        'Estimation',
        state$.value.estimations.searchQuery,
        state$.value.estimations.filters
    )}&limit=100`;
    if (getEstimationCurrentCursor(state$.value.products)) {
        url += '&cursor=' + getEstimationCurrentCursor(state$.value.products);
    }
    return backend.get(url).pipe(
        map((ajaxResponse: AjaxResponse) => new EstimationProductsReceived(ajaxResponse.response)),
        catchError((e: AjaxError) => of(new EstimationProductsGetFailed(), new RequestFailed(e.status))),
        startWith(new EstimationProductsGetRequested())
    );
};

export default combineEpics(immediately, withDelay);



// WEBPACK FOOTER //
// ./src/application/products/epic/getEstimationProducts.ts